<template>
  <div class="result-input">
    <div class="text-center">
      <v-progress-circular v-if="isLoading" indeterminate color="secondary" />
    </div>
    <v-alert
      v-if="!isCampaignStarted"
      border="left"
      colored-border
      type="info"
      elevation="2"
      style="font-size: 90%"
      class="my-4"
    >
      記録開始日（{{this.startDate}}）以降に入力欄が表示され、記録の入力が可能になります。
    </v-alert>
    <validation-observer ref="observer" slim v-if="!isLoading && isCampaignStarted">
      <v-form @submit.prevent="save">
        <div class="sticky_buttons">
          <v-btn
            type="submit"
            v-if="isCampaignPeriod"
            :disabled="!hasChange"
            :loading="isSubmitting"
            depressed
            color="pink"
            class="ma-3 hidden-sm-and-down"
            style="float:left; color:white !important;"
          >
            変更を保存する
          </v-btn>
          <v-btn
            type="submit"
            v-if="isCampaignPeriod"
            :disabled="!hasChange"
            :loading="isSubmitting"
            depressed
            color="pink"
            small
            class="ma-2 hidden-md-and-up"
            style="float:left; color:white !important;"
          >
            変更を保存する
          </v-btn>
          <v-btn
            @click="csvLine()"
            v-if="isCampaignStarted"
            :loading="isSubmitting"
            color="info"
            outlined
            class="ma-3 hidden-sm-and-down"
            style="width:120px; float:left"
          >
            CSV出力
          </v-btn>
          <GoogleFitStepCount
            v-if="stepCountIntegrateCourseId && isCampaignPeriod && campaign.is_step_count_google_fit"
            :dailyValueList="dailyValueList"
            :campaignUser="campaignUser"
            :isSubmitting="isSubmitting"
            :stepCountIntegrateCourseId="stepCountIntegrateCourseId"
            @inputErrorFromGoogleFit="inputErrorFromGoogleFit"
            @fetchDataFromGoogleFit="fetchDataFromGoogleFit"
            @googleAPISubmitting="googleAPISubmitting"
            class="google-fit-button"
          ></GoogleFitStepCount>
        </div>
        <v-snackbar
          v-model="showHasChange"
          color="pink"
          timeout="-1"
          bottom
        >
          記録をしたら、「変更を保存する」ボタンを押して下さい。
        </v-snackbar>
        <v-snackbar
          v-model="hasError"
          color="amber lighten-2"
          timeout="-1"
          bottom
          light
        >
          {{errorMessage}}
        </v-snackbar>

        <!-- PC -->
        <table class="sticky_table hidden-sm-and-down" v-if="dailyValueList.length > 0 && !isMobile">
          <colgroup style="width: 100%">
            <col class="col_date" />
            <col class="col_is_input" />
            <col v-for="(course) of selectedCourseList" :key="course.name" :class="'col_course_'+course.result_type" />
            <col class="col_blood_pressure" />
            <col class="col_blood_pressure" />
            <col class="col_memo" />
          </colgroup>
          <thead>
            <tr>
              <th>日付</th>
              <th>入力</th>
              <th v-for="(course) of selectedCourseList" :key="course.id">
                {{course.name}}
                <span v-if="course.custom_goal_setting">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" small>mdi-note</v-icon>
                    </template>
                    <span>{{course.custom_objective}}</span>
                  </v-tooltip>
                </span>
              </th>
              <th>血圧（上）</th>
              <th>血圧（下）</th>
              <th>メモ欄</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>{{totalDate}}日中のクリア</th>
              <th></th>
              <th v-for="(course) of selectedCourseList" :key="course.id">
                <span v-if="course.aggregate_result_info.is_completed && course.complete_type === 'UpperLimit'" class="primary--text">
                  <v-icon color="primary">mdi-check</v-icon>
                  完了
                </span>
                <span v-else>
                <!-- 達成の概念無し -->
                  <span v-if="course.complete_type === 'Daily_CircleAndCross' || course.complete_type === 'Daily_StandardValue'">
                    {{course.aggregate_result_info.clear_count}}日クリア
                  </span>
                  <span v-else-if="course.complete_type === 'Weekly_CircleAndCross'">
                    {{course.aggregate_result_info.clear_count}}週クリア
                  </span>
                  <span v-else-if="course.complete_type === 'UpperLimit'">
                    {{course.aggregate_result_info.clear_count}}回クリア
                  </span>
                </span>
              </th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
            <tr v-for="(dateValue) of dailyValueList" :key="dateValue.date" :class="dateValue.day === 0 || dateValue.day === 6 ? 'background_blue' : ''">
              <td style="text-align:center">
                <span v-if="dateValue.is_today" class="pink--text font-weight-bold">TODAY!<br></span>
                <span :class="dateValue.day === 0 ? 'pink--text' : (dateValue.day === 6 ? 'indigo--text' : '')">{{dateValue.show_date}}</span>
              </td>
              <td>
                <v-icon v-if="dateValue.is_inputted" color="light-green">mdi-check-circle</v-icon>
              </td>
              <td v-for="(course, index) of selectedCourseList" :key="course.id">
                <div v-if="course.result_type === 'Number'" style="width:100%; margin:0 auto; min-width: 70px important!;">
                  <keep-alive>
                    <validation-provider
                      :name="course.name"
                      :rules="setRule(course.result_type)"
                      v-slot="{ errors }"
                      :vid="'attribute-' + course.id + '-' + dateValue.date"
                    >
                      <v-text-field
                        :value="dateValue.select_course_result[index].number"
                        @input="changeNumberData($event, dateValue, index)"
                        :background-color="dateValue.select_course_result[index].number || dateValue.select_course_result[index].number === 0 ? null : 'lightpink'"
                        :disabled="isSubmitting || !isCampaignPeriod"
                        :suffix="course.unit"
                        :error-messages="errors"
                        type="text"
                        style="font-size:0.85rem; width:100%; margin:auto"
                        hide-details="auto"
                        dense />
                    </validation-provider>
                  </keep-alive>
                </div>
                <div v-if="course.result_type === 'Integer'" style="width:100%; margin:0 auto; min-width: 70px;">
                  <keep-alive>
                    <validation-provider
                      :name="course.name"
                      :rules="setRule(course.result_type)"
                      v-slot="{ errors }"
                      :vid="'attribute-' + course.id + '-' + dateValue.date"
                    >
                      <v-text-field
                        :value="dateValue.select_course_result[index].integer"
                        @input="changeIntegerData($event, dateValue, index)"
                        :background-color="dateValue.select_course_result[index].integer || dateValue.select_course_result[index].integer === 0 ? null : 'lightpink'"
                        :disabled="isSubmitting || !isCampaignPeriod"
                        :suffix="course.unit"
                        :error-messages="errors"
                        type="text"
                        style="font-size:0.85rem; width:100%; margin:auto"
                        hide-details="auto"
                        dense />
                      <v-chip
                        v-if="dateValue.select_course_result[index].is_manual"
                        class="mx-2 mt-2" small
                        color="primary"
                        outlined
                      >
                        手動入力
                      </v-chip>
                    </validation-provider>
                  </keep-alive>
                </div>
                <div v-if="course.result_type === 'CircleAndCross'" style="width:100%; margin:0 auto;">
                  <v-btn-toggle
                    :value="dateValue.select_course_result[index].circle_and_cross"
                    @change="changeCircleAndCrossData($event, dateValue, index)"
                    :background-color="dateValue.select_course_result[index].circle_and_cross ? null : 'lightpink'"
                    :disabled="isSubmitting || !isCampaignPeriod"
                    dense
                    color="green"
                    style="width:72px; margin:auto"
                  >
                    <v-btn value='circle' x-small class="py-3" :disabled="isSubmitting || !isCampaignPeriod">
                      <span style="font-size:12px" class="font-weight-black">〇</span>
                    </v-btn>
                    <v-btn value='cross' x-small class="py-3" :disabled="isSubmitting || !isCampaignPeriod">
                      <span style="font-size:16px" class="font-weight-black">×</span>
                    </v-btn>
                  </v-btn-toggle>
                </div>
                <div v-else-if="course.result_type === 'CircleCrossNone'" style="width:100%; margin:0 auto;">
                  <v-btn-toggle
                    :value="dateValue.select_course_result[index].circle_and_cross"
                    @change="changeCircleAndCrossData($event, dateValue, index)"
                    :background-color="dateValue.select_course_result[index].circle_and_cross ? null : 'lightpink'"
                    :disabled="isSubmitting || !isCampaignPeriod"
                    dense
                    color="green"
                    style="width:134px; margin:auto"
                  >
                    <v-btn value='circle' x-small class="py-3" :disabled="isSubmitting || !isCampaignPeriod">
                      <span style="font-size:12px" class="font-weight-black">〇</span>
                    </v-btn>
                    <v-btn value='cross' x-small class="py-3" :disabled="isSubmitting || !isCampaignPeriod">
                      <span style="font-size:16px" class="font-weight-black">×</span>
                    </v-btn>
                    <v-btn value='none' x-small class="py-3" :disabled="isSubmitting || !isCampaignPeriod">
                      <span class="font-weight-black">該当なし</span>
                    </v-btn>
                  </v-btn-toggle>
                </div>
              </td>
              <td>
                <keep-alive>
                  <validation-provider
                    name="血圧(上)"
                    :rules="setRule('bloodPressure')"
                    v-slot="{ errors }"
                    :vid="'attribute-top_blood_pressure-' + dateValue.date"
                  >
                    <v-text-field
                      :value="dateValue.top_blood_pressure"
                      @input="changeTopBloodPressure($event, dateValue)"
                      :disabled="isSubmitting || !isCampaignPeriod"
                      :error-messages="errors"
                      style="font-size:0.85rem"
                      type="text"
                      hide-details="auto"
                      dense
                    ></v-text-field>
                  </validation-provider>
                </keep-alive>
              </td>
              <td>
                <keep-alive>
                  <validation-provider
                    name="血圧(下)"
                    :rules="setRule('bloodPressure')"
                    v-slot="{ errors }"
                    :vid="'attribute-bottom_blood_pressure-' + dateValue.date"
                  >
                    <v-text-field
                      :value="dateValue.bottom_blood_pressure"
                      @input="changeBottomBloodPressure($event, dateValue)"
                      :disabled="isSubmitting || !isCampaignPeriod"
                      :error-messages="errors"
                      style="font-size:0.85rem"
                      type="text"
                      hide-details="auto"
                      dense />
                  </validation-provider>
                </keep-alive>
              </td>
              <td>
                <v-textarea
                  :value="dateValue.disp_note"
                  @input="changeNote($event, dateValue)"
                  rows="2"
                  :disabled="isSubmitting || !isCampaignPeriod"
                  style="font-size:0.75rem;"
                  hide-details="auto"
                  dense />
              </td>
            </tr>
          </tbody>
        </table>

        <!--モバイル-->
        <v-expansion-panels accordion focusable tile flat class="mb-6" v-if="dailyValueList.length > 0 && isMobile">
          <v-expansion-panel v-for="(dateValue) of dailyValueList" :key="dateValue.date" class="mobile-panel">
            <v-expansion-panel-header :disable-icon-rotate="dateValue.is_inputted">
              <span :class="dateValue.day === 0 ? 'pink--text' : (dateValue.day === 6 ? 'indigo--text' : '')">{{dateValue.show_date}}</span>
              <span v-if="dateValue.is_today" class="pink--text font-weight-bold">TODAY!</span>
              <template v-slot:actions>
                <v-icon v-if="dateValue.is_inputted" color="light-green">mdi-check-circle</v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="ma-3">
              <v-row>
                <v-col cols="12" sm="6" v-for="(course, index) of selectedCourseList" :key="course.id">
                  <div v-if="course.result_type === 'Number'">
                    <validation-provider
                      :name="course.name"
                      :rules="setRule(course.result_type)"
                      v-slot="{ errors }"
                    >
                      <div class="mobile-label">{{course.name}}</div>
                      <v-text-field
                        :value="dateValue.select_course_result[index].number"
                        @input="changeNumberData($event, dateValue, index)"
                        :background-color="dateValue.select_course_result[index].number || dateValue.select_course_result[index].number === 0 ? null : 'lightpink'"
                        :disabled="isSubmitting || !isCampaignPeriod"
                        :suffix="course.unit"
                        :error-messages="errors"
                        :class="'mobile-course-' + course.result_type"
                        type="text"
                        inputmode="decimal"
                        hide-details="auto"
                        outlined
                        dense />
                    </validation-provider>
                  </div>
                  <div v-if="course.result_type === 'Integer'">
                    <validation-provider
                      :name="course.name"
                      :rules="setRule(course.result_type)"
                      v-slot="{ errors }"
                    >
                      <div class="mobile-label">{{course.name}}</div>
                      <v-text-field
                        :value="dateValue.select_course_result[index].integer"
                        @input="changeIntegerData($event, dateValue, index)"
                        :background-color="dateValue.select_course_result[index].integer || dateValue.select_course_result[index].integer === 0 ? null : 'lightpink'"
                        :disabled="isSubmitting || !isCampaignPeriod"
                        :suffix="course.unit"
                        :error-messages="errors"
                        :class="'mobile-course-' + course.result_type"
                        type="tel"
                        hide-details="auto"
                        outlined
                        dense
                        style="float:left" />
                      <div style="width:88px; float:left;">
                        <v-chip
                          v-if="dateValue.select_course_result[index].is_manual"
                          class="mx-2 mt-2" small
                          color="primary"
                          outlined
                        >
                          手動入力
                        </v-chip>
                      </div>
                    </validation-provider>
                  </div>
                  <div v-if="course.result_type === 'CircleAndCross'">
                    <div class="mobile-label">
                      {{course.name}}
                      <span v-if="course.custom_goal_setting">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">mdi-note</v-icon>
                          </template>
                          <span>{{course.custom_objective}}</span>
                        </v-tooltip>
                      </span>
                    </div>
                    <v-btn-toggle
                      :value="dateValue.select_course_result[index].circle_and_cross"
                      @change="changeCircleAndCrossData($event, dateValue, index)"
                      :background-color="dateValue.select_course_result[index].circle_and_cross ? null : 'lightpink'"
                      :disabled="isSubmitting || !isCampaignPeriod"
                      :class="'mobile-course-' + course.result_type"
                      style="width:128px !important"
                      color="green"
                      dense
                    >
                      <v-btn value='circle' style="width: 50%;" class="py-3" :disabled="isSubmitting || !isCampaignPeriod">
                        <span style="font-size:12px" class="font-weight-black">〇</span>
                      </v-btn>
                      <v-btn value='cross' style="width: 50%;" class="py-3" :disabled="isSubmitting || !isCampaignPeriod">
                        <span style="font-size:16px" class="font-weight-black">×</span>
                      </v-btn>
                    </v-btn-toggle>
                  </div>
                  <div v-if="course.result_type === 'CircleCrossNone'">
                    <div class="mobile-label">{{course.name}}</div>
                    <v-btn-toggle
                      :value="dateValue.select_course_result[index].circle_and_cross"
                      @change="changeCircleAndCrossData($event, dateValue, index)"
                      :background-color="dateValue.select_course_result[index].circle_and_cross ? null : 'lightpink'"
                      :disabled="isSubmitting || !isCampaignPeriod"
                      :class="'mobile-course-' + course.result_type"
                      style="width:207px !important"
                      color="green"
                      dense
                    >
                      <v-btn value='circle' style="width: 28%;" class="py-3" :disabled="isSubmitting || !isCampaignPeriod">
                        <span style="font-size:12px" class="font-weight-black">〇</span>
                      </v-btn>
                      <v-btn value='cross' style="width: 28%;" class="py-3" :disabled="isSubmitting || !isCampaignPeriod">
                        <span style="font-size:16px" class="font-weight-black">×</span>
                      </v-btn>
                      <v-btn value='none' style="width: 44%;" class="py-3" :disabled="isSubmitting || !isCampaignPeriod">
                        <span class="font-weight-black">該当なし</span>
                      </v-btn>
                    </v-btn-toggle>
                  </div>
                </v-col>
              </v-row>
              <v-row class="mt-6">
                <v-col cols="6">
                  <validation-provider
                    name="血圧(上)"
                    :rules="setRule('bloodPressure')"
                    v-slot="{ errors }"
                  >
                    <div class="mobile-label">血圧(上)</div>
                    <v-text-field
                      :value="dateValue.top_blood_pressure"
                      @input="changeTopBloodPressure($event, dateValue)"
                      :disabled="isSubmitting || !isCampaignPeriod"
                      :error-messages="errors"
                      type="tel"
                      hide-details="auto"
                      outlined
                      dense />
                  </validation-provider>
                </v-col>
                <v-col cols="6">
                  <validation-provider
                    name="血圧(下)"
                    :rules="setRule('bloodPressure')"
                    v-slot="{ errors }"
                  >
                    <div class="mobile-label">血圧(下)</div>
                    <v-text-field
                      :value="dateValue.bottom_blood_pressure"
                      @input="changeBottomBloodPressure($event, dateValue)"
                      :disabled="isSubmitting || !isCampaignPeriod"
                      :error-messages="errors"
                      type="tel"
                      hide-details="auto"
                      outlined
                      dense />
                  </validation-provider>
                </v-col>
                <v-col cols="12">
                  <div class="mobile-label">メモ欄</div>
                  <v-textarea
                    :value="dateValue.note"
                    @input="changeNote($event, dateValue)"
                    rows="4"
                    :disabled="isSubmitting || !isCampaignPeriod"
                    hide-details="auto"
                    outlined
                    dense />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>
    </validation-observer>
    <SuccessSnackbar ref="snackbar"/>
    <ContinueBonusDialog ref="dialog"/>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
import JsonToCsv from '../../utils/JsonToCsv'
import { integer, max_value as maxValue, min_value as minValue, regex } from 'vee-validate/dist/rules'
import { localize, extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja.json'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
dayjs.locale('ja')
const SuccessSnackbar = () => import('../util/SuccessSnackbar.vue')
const ContinueBonusDialog = () => import('./ContinueBonusDialog.vue')
const GoogleFitStepCount = () => import('./google_fit/StepCount.vue')

// バリデーションの定義
setInteractionMode('eager')
localize('ja', ja)
extend('max_value', {
  ...maxValue,
  message: '{_field_}は{max}以内で入力してください'
})
extend('min_value', {
  ...minValue,
  message: '{_field_}は{min}以上で入力してください'
})
extend('regex', {
  ...regex,
  message: '{_field_}は半角数字（小数点第二位まで）で入力してください'
})
extend('integer', {
  ...integer,
  message: '{_field_}は半角数字（整数）で入力してください'
})

const convertArrayString = (arrayData) => {
  const resArry = arrayData.map(obj => {
    const arr = Object.keys(obj).map(key => {
      if (obj[key] instanceof Array) {
        const courseArry = obj[key]
        const arr2 = courseArry.map(obj2 => {
          const objStr = Object.keys(obj2).map(key2 => {
            if (obj2[key2] === 0 || obj2[key2]) {
              if (typeof obj2[key2] === 'number' || typeof obj2[key2] === 'boolean') {
                return `${key2}: ${obj2[key2]}`
              } else {
                return `${key2}: "${obj2[key2]}"`
              }
            }
          })
          return `{${objStr.join(', ')}}`
        })
        const arr2str = `[${arr2.join(', ')}]`
        return `${key}: ${arr2str}`
      } else if (typeof obj[key] === 'number' || typeof obj[key] === 'boolean') {
        return `${key}: ${obj[key]}`
      } else if (obj[key]) {
        return `${key}: ${JSON.stringify(obj[key])}`
      }
    })
    return `{${arr.join(', ')}}`
  })
  return `[${resArry.join(', ')}]`
}

const convertObjString = (obj) => {
  const arr = Object.keys(obj).map((key) => {
    if (typeof obj[key] === 'number' || typeof obj[key] === 'boolean') {
      return `${key}: ${obj[key]}`
    }
  })
  return `{${arr.join(',')}}`
}

const saveResultMutation = (campaignId, dailyResultInputList, saveResultInputOption) => `
  mutation saveResult {
    saveResult(
      input: {
        campaign_id: "${campaignId}",
        daily_result: ${convertArrayString(dailyResultInputList)},
        save_result_option: ${convertObjString(saveResultInputOption)}
      }
    )
  }
`
const saveResult = async (campaignId, dailyResultInputList, saveResultInputOption) => {
  const { data: { saveResult: data } } = await GraphqlAPI(saveResultMutation(campaignId, dailyResultInputList, saveResultInputOption))
  return data
}

const getCourseValue = (resultType, selectCourse) => {
  switch (resultType) {
    case 'CircleAndCross':
      return nullToEmpty(CIRCLE_CROSS_VALUE[selectCourse.circle_and_cross])
    case 'CircleCrossNone':
      return nullToEmpty(CIRCLE_CROSS_VALUE[selectCourse.circle_and_cross])
    case 'Integer':
      return nullToEmpty(selectCourse.integer)
    case 'Number':
      return nullToEmpty(selectCourse.number)
  }
}

const CIRCLE_CROSS_VALUE = {
  circle: '○',
  cross: '×',
  none: '該当なし'
}

const nullToEmpty = (item) => {
  if (item === null || typeof item === 'undefined') {
    return ''
  }
  return item
}

export default {
  mixins: [JsonToCsv],
  name: 'result',
  data () {
    return {
      dailyValueList: [],
      originDailyValueList: [],
      updateDailyValueList: [],
      targetDateList: [],
      selectedCourseList: [],
      isCampaignPeriod: false,
      isCampaignStarted: false,
      startDate: null,
      isSubmitting: false,
      totalDate: null,
      elapsedDate: null,
      isLoading: false,
      hasError: false,
      errorMessage: null,
      hasChange: false,
      showHasChange: false,
      // 歩数連動機能
      stepCountIntegrateCourseId: null,
      manualList: new Set()
    }
  },
  props: [
    'campaignUser',
    'propsDailyValueList'
  ],
  components: {
    ValidationProvider,
    ValidationObserver,
    SuccessSnackbar,
    ContinueBonusDialog,
    GoogleFitStepCount
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    },
    isMobile () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    }
  },
  watch: {
    propsDailyValueList: {
      handler (newValue) {
        if (newValue !== null) {
          this.resultListFormatter(newValue)
          this.originDailyValueList = this.dailyValueList.map(list => ({ ...list }))
        }
      },
      deep: true
    },
    hasChange (newValue) {
      this.showHasChange = newValue && !this.hasError
    },
    hasError (newValue) {
      this.showHasChange = this.hasChange && !newValue
    }
  },
  async created () {
    if (!this.campaign.id) {
      await this.$store.dispatch('initCampaign')
    }
    this.isLoading = true
    // 対象期間の取得
    this.startDate = dayjs(this.campaign.start, 'YYYY-MM-DD').format('M/D')
    const startDate = dayjs(this.campaign.start, 'YYYY-MM-DD')
    const endDate = dayjs(this.campaign.end, 'YYYY-MM-DD')
    const siteClose = dayjs('2026-12-16', 'YYYY-MM-DD').add(1, 'days') // TODO:操作できなくなる日付を手で設定する
    this.isCampaignPeriod = dayjs() >= startDate && dayjs() < siteClose
    this.isCampaignStarted = dayjs() >= startDate

    let countDate = startDate.clone()
    while (countDate.unix() <= endDate.unix() && countDate <= dayjs()) {
      this.targetDateList.push(countDate.format('YYYY-MM-DD'))
      countDate = countDate.add(1, 'days')
    }
    this.targetDateList.reverse()

    this.totalDate = endDate.diff(startDate, 'days') + 1
    // 記録情報の取得
    if (this.propsDailyValueList !== null) {
      this.resultListFormatter(this.propsDailyValueList)
      this.originDailyValueList = this.dailyValueList.map(list => ({ ...list }))
    }
  },
  methods: {
    resultListFormatter (listDailyResult) {
      this.isLoading = true
      this.dailyValueList = []
      this.selectedCourseList = []
      const dailyResultList = listDailyResult.daily_results
      const selectedCourseList = listDailyResult.select_course_list
      const descTargetDateList = Array.from(this.targetDateList)
      const me = this
      for (const selectedCourse of listDailyResult.select_course_list) {
        const targetCourse = this.campaignUser.custom_objective_list.find(elm => {
          return elm.course_id === selectedCourse.id
        })
        this.selectedCourseList.push({
          ...selectedCourse,
          custom_objective: targetCourse.custom_objective
        })
      }

      // 歩数コースに参加していたら、IDを取得
      this.stepCountIntegrateCourseId = selectedCourseList.find(elm => elm.unit === '歩')?.id

      for (const date of descTargetDateList) {
        const dailyResultObj = dailyResultList.find(elm => date === elm.meta)
        // 対象日の結果情報があるとき
        if (dailyResultObj) {
          const valueObj = {
            date: dayjs(dailyResultObj.meta).format('YYYY-MM-DD'),
            show_date: dayjs(dailyResultObj.meta).format('YYYY/MM/DD(dd)'),
            day: dayjs(dailyResultObj.meta).day(),
            is_today: dailyResultObj.meta === dayjs().format('YYYY-MM-DD'),
            is_inputted: dailyResultObj.is_inputted,
            top_blood_pressure: dailyResultObj.top_blood_pressure,
            bottom_blood_pressure: dailyResultObj.bottom_blood_pressure,
            note: dailyResultObj.note,
            disp_note: dailyResultObj.note
          }
          if (dailyResultObj.select_course_result) {
            const courseList = []
            for (const selectCourse of selectedCourseList) {
              const existCourse = dailyResultObj.select_course_result.find(pastCourseResult => {
                return pastCourseResult.course_id === selectCourse.id
              })
              courseList.push({
                course_id: selectCourse.id,
                circle_and_cross: existCourse ? existCourse.circle_and_cross : null,
                integer: existCourse ? existCourse.integer : null,
                number: existCourse ? existCourse.number : null,
                is_manual: existCourse ? existCourse.is_manual : null
              })
            }
            valueObj.select_course_result = courseList
          }
          me.dailyValueList.push(valueObj)

        // 対象日の結果情報がないとき（空のオブジェクトを返す）
        } else {
          const selectCourseResult = []
          for (const elm of selectedCourseList) {
            selectCourseResult.push({
              course_id: elm.id,
              circle_and_cross: null,
              integer: null,
              number: null
            })
          }
          const obj = {
            date: dayjs(date).format('YYYY-MM-DD'),
            show_date: dayjs(date).format('YYYY/MM/DD(dd)'),
            day: dayjs(date).day(),
            is_today: date === dayjs().format('YYYY-MM-DD'),
            is_inputted: false,
            top_blood_pressure: null,
            bottom_blood_pressure: null,
            note: null,
            select_course_result: selectCourseResult
          }
          me.dailyValueList.push(obj)
        }
      }
      this.isLoading = false
    },
    changeNumberData (event, dateValue, index) {
      dateValue.select_course_result[index].number = event
      this.changeData(dateValue)
    },
    changeIntegerData (event, dateValue, index) {
      if (dateValue.select_course_result[index].course_id === this.stepCountIntegrateCourseId) {
        this.manualList.add(dateValue.date)
      }
      dateValue.select_course_result[index].integer = event
      this.changeData(dateValue)
    },
    changeCircleAndCrossData (event, dateValue, index) {
      dateValue.select_course_result[index].circle_and_cross = event
      this.changeData(dateValue)
    },
    changeTopBloodPressure (event, dateValue) {
      dateValue.top_blood_pressure = event
      this.changeData(dateValue)
    },
    changeBottomBloodPressure (event, dateValue) {
      dateValue.bottom_blood_pressure = event
      this.changeData(dateValue)
    },
    changeNote (event, dateValue) {
      dateValue.note = event
      this.changeData(dateValue)
    },
    changeData (dateValue) {
      this.hasChange = true
      const targetDailyData = this.updateDailyValueList.some((elm, i) => {
        return elm.date === dateValue.date
      })
      if (targetDailyData) {
      } else {
        this.updateDailyValueList.push(dateValue)
      }
    },
    setRule (resultType) {
      const ruleList = {}
      if (resultType === 'Integer') {
        ruleList.integer = true
        ruleList.max_value = 99999
        ruleList.min_value = 0
      }
      if (resultType === 'Number') {
        ruleList.regex = /(^[0-9\-+]+)(?:\.[0-9]{0,2})?$/
        ruleList.max_value = 1000
        ruleList.min_value = 0
      }
      if (resultType === 'bloodPressure') {
        ruleList.integer = true
        ruleList.max_value = 500
        ruleList.min_value = 0
      }
      return ruleList
    },
    csvLine () {
      this.isSubmitting = true
      const csvData = []
      if (this.selectedCourseList) {
        for (const selectCourse of this.selectedCourseList) {
          csvData.push({
            コース名: selectCourse.name,
            コースID: selectCourse.id
          })
        }
        csvData.push({ コース名: '上の血圧' })
        csvData.push({ コース名: '下の血圧' })
        csvData.push({ コース名: 'メモ欄' })

        const deepCopyList = this.originDailyValueList.map(list => ({ ...list }))
        for (const dailyResult of deepCopyList.reverse()) {
          // 1日の結果毎に格納
          const targetDate = dailyResult.show_date
          for (const result of dailyResult.select_course_result) {
            const csvRow = csvData.find(csvRow => csvRow['コースID'] === result.course_id)
            csvRow[targetDate] = this.getResultValue(result)
          }
          const topBloodPressure = csvData.find(csvRow => csvRow['コース名'] === '上の血圧')
          topBloodPressure[targetDate] = nullToEmpty(dailyResult.top_blood_pressure)
          const bottomBloodPressure = csvData.find(csvRow => csvRow['コース名'] === '下の血圧')
          bottomBloodPressure[targetDate] = nullToEmpty(dailyResult.bottom_blood_pressure)
          const note = csvData.find(csvRow => csvRow['コース名'] === 'メモ欄')
          note[targetDate] = nullToEmpty(dailyResult.note)
        }
        for (const row of csvData) {
          delete row['コースID']
        }
      }
      const filename = 'CourseResultList'
      const csvTitle = filename + '_' + this.$_getDateString() + '.csv'
      const labels = Object.getOwnPropertyNames({ ...csvData[0] })
      const labelsConf = this.$_createCsvLabelsConf(labels)
      const separator = ','
      this.$_jsonToCsv(csvTitle, csvData, labelsConf, separator)
      this.isSubmitting = false
    },
    getResultValue (result) {
      const resultType = this.findResultType(result.course_id)
      return getCourseValue(resultType, result)
    },
    findResultType (courseId) {
      const courseInfo = this.selectedCourseList.find(elm => courseId === elm.id)
      return courseInfo.result_type
    },
    async save () {
      this.isSubmitting = true
      this.hasError = false
      const isValidateError = await this.$refs.observer.validate()
      if (!isValidateError) {
        this.hasError = true
        this.errorMessage = '入力内容にエラーがあります。確認してください。'
        this.isSubmitting = false
        return false
      }
      if (this.updateDailyValueList.length === 0) {
        this.isSubmitting = false
        await this.$refs.snackbar.open('変更がありませんでした。')
        return false
      }

      const filteredList = []
      // 保存用にレコードを整形
      this.updateDailyValueList.forEach(dv => {
        const filteredCourseList = []
        for (const ce of dv.select_course_result) {
          this.manualList.has(dv.date)
          if (ce.course_id === this.stepCountIntegrateCourseId) {
            filteredCourseList.push({
              course_id: ce.course_id,
              circle_and_cross: ce.circle_and_cross,
              integer: (ce.integer === 0 || ce.integer) ? parseInt(ce.integer) : null,
              number: (ce.number === 0 || ce.number) ? parseFloat(ce.number) : null,
              is_manual: Boolean((ce.integer === 0 || ce.integer) && this.manualList.has(dv.date))
            })
          } else {
            filteredCourseList.push({
              course_id: ce.course_id,
              circle_and_cross: ce.circle_and_cross,
              integer: (ce.integer === 0 || ce.integer) ? parseInt(ce.integer) : null,
              number: (ce.number === 0 || ce.number) ? parseFloat(ce.number) : null
            })
          }
        }
        const newDv = {}
        if (dv.top_blood_pressure || dv.bottom_blood_pressure || dv.note || (filteredCourseList && filteredCourseList.length > 0)) {
          newDv.date = dv.date
          newDv.top_blood_pressure = dv.top_blood_pressure ? parseInt(dv.top_blood_pressure) : null
          newDv.bottom_blood_pressure = dv.bottom_blood_pressure ? parseInt(dv.bottom_blood_pressure) : null
          newDv.note = dv.note ? dv.note : null
          newDv.select_course_result = filteredCourseList
          filteredList.push(newDv)
        }
      })
      try {
        const saveResultInputOption = {}

        // 継続ボーナス付与
        let continueBonusOutput
        if (this.campaign.is_continue_bonus) {
          continueBonusOutput = await this.$store.dispatch('setContinueBonusProcessorOutput', { campaignId: this.campaign.id, type: 'write' })
          saveResultInputOption.is_continue_bonus_complete = continueBonusOutput.is_continue_bonus_complete
          saveResultInputOption.continue_bonus_point = continueBonusOutput.continue_bonus_point
        }

        // ※継続ボーナスポイント(CampaignUser, Userview)更新、を含む
        const saveResultResponse = await saveResult(this.campaign.id, filteredList, saveResultInputOption)

        // 保持データの更新
        this.$emit('fetchData', async () => {
          this.updateDailyValueList = []
          this.hasChange = false
          this.isSubmitting = false
          if (saveResultResponse === 'ALL_RESULTS_SAVED') {
            this.$refs.snackbar.open('結果記録が保存されました。')
          } else if (saveResultResponse === 'INVALID_DATE_CONTAIN') {
            this.$refs.snackbar.open('未来日のデータが含まれていたため、一部の保存が失敗しました。')
          }
        })

        // 継続ボーナスダイアログの表示
        if (this.campaign.is_continue_bonus && continueBonusOutput && continueBonusOutput.first_continue.status) {
          await this.$refs.dialog.open({ completeIndex: continueBonusOutput.first_continue.index + 1 })
        }
      } catch (e) {
        this.$emit('inputError', '結果記録の保存に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
        this.isSubmitting = false
      }
    },
    inputErrorFromGoogleFit (errorMessage) {
      this.$emit('inputError', errorMessage)
    },
    async fetchDataFromGoogleFit () {
      this.$emit('fetchData', () => {
        this.googleAPISubmitting(false)
        this.$refs.snackbar.open('Google Fitから結果記録が保存されました。<br/>入力情報に不足がある場合は、一度Google Fitアプリを起動してから再度お試しください。')
      })
    },
    googleAPISubmitting (isSubmitting) {
      this.isSubmitting = isSubmitting
    }
  }
}
</script>

<style lang="scss">
.sticky_table {
  font-size: 0.75rem;
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
  th, td {
    height: 30px;
    vertical-align: middle;
    padding: 5px;
    border: 1px solid #ccc;
  }
  thead th {
    position: -webkit-sticky; /* safari */
    position: sticky;
    top: 110px;
    color: #333;
    z-index: 2;
    background-color: #FFF8E1;
  }
  .col_date {
    width: 110px;
  }
  .col_is_input {
    width: 35px;
  }
  .col_blood_pressure {
    width: 70px;
  }
  .col_course_Number, .col_course_Integer {
    margin:0 auto;
    width: 100px;
    padding: 0 5px;
  }
  .col_course_CircleAndCross {
    margin:0 auto;
    width: 82px;
    padding: 0 5px;
  }
  .col_course_CircleCrossNone {
    margin:0 auto;
    width: 145px;
    padding: 0 5px;
  }
}
.sticky_buttons {
  position: -webkit-sticky; /* safari */
  position: sticky;
  top: 47px;
  height: 65px;
  z-index: 2;
  background: #FFFFFF;
  width: 100%;
  transform: translateX(0%);
}
.google-fit-button {
  width: 220px;
  float: left;
}
@media (max-width: 600px) {
  .google-fit-button {
    width: 180px;
  }
}
.v-textarea textarea {
  line-height: 1.15rem !important;
}
.v-window {
  overflow: visible !important;
}
.background_blue {
  background-color: #E6F1FF;
}
.mobile-course-Number {
  display: block;
  width: 120px;
  margin: 0 auto;
}
.mobile-course-Integer {
  display: block;
  width: 120px;
  margin: 0 auto;
}
.mobile-course-CircleAndCross {
  display: block;
  width: 92px !important;
}
.mobile-course-CircleCrossNone {
  display: block;
  width: 211px;
}
.mobile-label {
  font-size: 0.8rem;
}
.mobile-panel {
  border-bottom: solid 1px #ddd;
}
.theme--light.v-btn.v-btn--has-bg {
  background-color: transparent;
}
</style>
